/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Beweegthema_Aangepastesportspelen3Inputs */

const nl_enums_beweegthema_aangepastesportspelen3 = /** @type {(inputs: Enums_Beweegthema_Aangepastesportspelen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangepaste sportspelen`)
};

/**

* @param {Enums_Beweegthema_Aangepastesportspelen3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_beweegthema_aangepastesportspelen3 = /** @type {((inputs?: Enums_Beweegthema_Aangepastesportspelen3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Beweegthema_Aangepastesportspelen3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_beweegthema_aangepastesportspelen3(inputs)
});
export { enums_beweegthema_aangepastesportspelen3 as "enums.Beweegthema.AangepasteSportspelen" }